import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Modal } from 'semantic-ui-react';

import StatefulModal from 'Components/Modal/StatefulModal';
import CreateEditForm from 'Containers/CreateEditForm';
import {
  createCareerPlanMutation,
  updateCareerPlanMutation,
} from 'GraphQL/LSP/mutation/Education.mutation';
import { getCareerPlans, getCareerPlan } from 'GraphQL/LSP/query/Education.query';

import CareerPlanForm from './CareerPlanForm';

export default class CareerPlanModal extends Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    id: PropTypes.string,
    trigger: PropTypes.element,
  };
  static defaultProps = {
    isEdit: false,
  };
  render() {
    const { isEdit, id, trigger, variables } = this.props;
    return (
      <StatefulModal trigger={trigger} dimmer="inverted">
        {(closeModal) => (
          <Fragment>
            <Modal.Header>{isEdit ? 'แก้ไขแผนอาชีพ' : 'สร้างแผนอาชีพ'}</Modal.Header>
            <Modal.Content>
              <CreateEditForm
                dataQuery={getCareerPlan}
                createMutation={createCareerPlanMutation}
                createRefetchQueries={[
                  {
                    query: getCareerPlans,
                    variables,
                  },
                ]}
                editMutation={updateCareerPlanMutation}
                isEdit={isEdit}
                id={id}
                getQueryVariables={({ id }) => ({
                  id,
                })}
                getEditVariables={(form, { id }) => ({
                  id,
                  careerPlanData: form,
                })}
                getCreateVariables={(form) => ({
                  careerPlanData: form,
                })}
                onCompleted={closeModal}
                onCancelled={closeModal}
              >
                {({ data, onSubmit }) => {
                  return (
                    <CareerPlanForm initialData={data && data.boCareerPlan} onSubmit={onSubmit} />
                  );
                }}
              </CreateEditForm>
            </Modal.Content>
          </Fragment>
        )}
      </StatefulModal>
    );
  }
}
